(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["printgorilla"] && !Shopify.designMode) return;
  try {
    
(() => {
function parseSTL(buffer) {
 const view=new DataView(buffer);let values;
 const count=buffer.byteLength>=84?view.getUint32(80,true):0;
 if(count>0&&84+count*50<=buffer.byteLength){
  if(count>1000000)throw Error('Too many triangles');values=new Float32Array(count*9);
  for(let i=0;i<count;i++)for(let j=0;j<9;j++)values[i*9+j]=view.getFloat32(84+i*50+12+j*4,true);
 }else{
  const text=new TextDecoder().decode(buffer),numbers=[];
  const re=/vertex\s+([-+\d.eE]+)\s+([-+\d.eE]+)\s+([-+\d.eE]+)/g;let match;
  while((match=re.exec(text))){numbers.push(Number(match[1]),Number(match[2]),Number(match[3]));if(numbers.length>9000000)throw Error('Too many triangles');}
  if(!numbers.length||numbers.length%9)throw Error('Invalid STL');values=new Float32Array(numbers);
 }
 let min=[Infinity,Infinity,Infinity],max=[-Infinity,-Infinity,-Infinity];
 for(let i=0;i<values.length;i++){if(!Number.isFinite(values[i]))throw Error('Invalid coordinate');let k=i%3;min[k]=Math.min(min[k],values[i]);max[k]=Math.max(max[k],values[i]);}
 const centre=min.map((v,k)=>(v+max[k])/2),scale=Math.hypot(...max.map((v,k)=>v-min[k]))/2;
 if(!Number.isFinite(scale)||scale<=0)throw Error('Empty STL');
 const normals=new Float32Array(values.length);
 for(let i=0;i<values.length;i++)values[i]=(values[i]-centre[i%3])/scale;
 for(let i=0;i<values.length;i+=9){
  const a=[values[i+3]-values[i],values[i+4]-values[i+1],values[i+5]-values[i+2]],b=[values[i+6]-values[i],values[i+7]-values[i+1],values[i+8]-values[i+2]];
  const n=[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]],len=Math.hypot(...n)||1;
  for(let j=0;j<9;j++)normals[i+j]=n[j%3]/len;
 }
 return {values,normals};
}
function init(root){
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const canvas=root.querySelector('[data-pg-canvas]'),image=root.querySelector('[data-pg-image]'),placeholder=root.querySelector('[data-pg-placeholder]'),status=root.querySelector('[data-pg-status]'),tools=root.querySelector('[data-pg-tools]');
 let gl,program,buffers=[],vertices=0,yaw=-.6,pitch=.65,zoom=1,url,version=0,disposed=false;
 function shader(type,source){const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error('Shader unavailable');return s;}
 function setup(){
  if(gl)return;gl=canvas.getContext('webgl',{antialias:true,alpha:false});if(!gl)throw Error('3D is unavailable');
  const vs=shader(gl.VERTEX_SHADER,'attribute vec3 position;attribute vec3 normal;uniform vec2 angles;uniform vec2 fit;varying float light;vec3 rot(vec3 p){float c=cos(angles.x),s=sin(angles.x),a=cos(angles.y),b=sin(angles.y);vec3 v=vec3(c*p.x-s*p.y,s*p.x+c*p.y,p.z);return vec3(v.x,a*v.z-b*v.y,-a*v.y-b*v.z);}void main(){vec3 p=rot(position);gl_Position=vec4(p.xy*fit,p.z*.35,1.0);vec3 n=rot(normal);light=.3+.7*abs(dot(normalize(n),normalize(vec3(-.3,.6,1.))));}');
  const fs=shader(gl.FRAGMENT_SHADER,'precision mediump float;varying float light;void main(){gl_FragColor=vec4(vec3(1.0,.37,.045)*light,1.0);}');
  program=gl.createProgram();gl.attachShader(program,vs);gl.attachShader(program,fs);gl.linkProgram(program);gl.deleteShader(vs);gl.deleteShader(fs);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('3D is unavailable');
  gl.useProgram(program);gl.enable(gl.DEPTH_TEST);gl.clearColor(.032,.032,.032,1);
 }
 function draw(){if(!gl||!vertices||canvas.hidden||disposed)return;const ratio=Math.min(devicePixelRatio||1,2),w=Math.max(1,Math.round(canvas.clientWidth*ratio)),h=Math.max(1,Math.round(canvas.clientHeight*ratio));canvas.width=w;canvas.height=h;gl.viewport(0,0,w,h);gl.useProgram(program);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.uniform2f(gl.getUniformLocation(program,'angles'),yaw,pitch);gl.uniform2f(gl.getUniformLocation(program,'fit'),.88*zoom*Math.min(1,h/w),.88*zoom*Math.min(1,w/h));gl.drawArrays(gl.TRIANGLES,0,vertices);}
 function reset(){yaw=-.6;pitch=.65;zoom=1;draw();}
 function zoomBy(f){zoom=Math.max(.2,Math.min(8,zoom*f));draw();}
 async function preview(file){const token=++version;canvas.hidden=true;image.hidden=true;tools.hidden=true;placeholder.hidden=false;if(url){URL.revokeObjectURL(url);url=null;}if(!file){status.textContent=root.dataset.empty;return;}status.textContent=root.dataset.loading;
  try{
   if(file.size>50*1024*1024){status.textContent=root.dataset.large;return;}
   if(/\.stl$/i.test(file.name)){
    const buffer=await file.arrayBuffer();if(token!==version||disposed)return;const mesh=parseSTL(buffer);setup();buffers.forEach(b=>gl.deleteBuffer(b));buffers=[];
    for(const [name,data] of [['position',mesh.values],['normal',mesh.normals]]){const b=gl.createBuffer();buffers.push(b);gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,data,gl.STATIC_DRAW);const at=gl.getAttribLocation(program,name);gl.enableVertexAttribArray(at);gl.vertexAttribPointer(at,3,gl.FLOAT,false,0,0);}
    vertices=mesh.values.length/3;placeholder.hidden=true;canvas.hidden=false;tools.hidden=false;reset();
   }else if(/\.(png|jpe?g|webp|gif)$/i.test(file.name)){
    url=URL.createObjectURL(file);image.src=url;await image.decode();if(token!==version||disposed)return;placeholder.hidden=true;image.hidden=false;
   }else{status.textContent=root.dataset.unsupported;return;}
   status.textContent=file.name+' — '+root.dataset.ready;
  }catch(e){if(token===version&&!disposed)status.textContent=root.dataset.error;}
 }
 root.addEventListener('change',e=>{if(e.target.matches('input[type="file"]'))preview(e.target.files?.[0]);},true);
 root.querySelector('[data-pg-reset]').onclick=reset;root.querySelector('[data-pg-in]').onclick=()=>zoomBy(1.2);root.querySelector('[data-pg-out]').onclick=()=>zoomBy(1/1.2);
 const pointers=new Map();let distance=0;
 canvas.addEventListener('pointerdown',e=>{canvas.setPointerCapture(e.pointerId);pointers.set(e.pointerId,[e.clientX,e.clientY]);if(pointers.size===2){const [a,b]=[...pointers.values()];distance=Math.hypot(a[0]-b[0],a[1]-b[1]);}});
 canvas.addEventListener('pointermove',e=>{const old=pointers.get(e.pointerId);if(!old)return;pointers.set(e.pointerId,[e.clientX,e.clientY]);if(pointers.size===2){const [a,b]=[...pointers.values()],next=Math.hypot(a[0]-b[0],a[1]-b[1]);if(distance>0)zoomBy(next/distance);distance=next;}else{yaw+=(e.clientX-old[0])*.01;pitch=Math.max(-1.5,Math.min(1.5,pitch+(e.clientY-old[1])*.01));draw();}});
 for(const type of ['pointerup','pointercancel','lostpointercapture'])canvas.addEventListener(type,e=>{pointers.delete(e.pointerId);distance=0;});
 canvas.addEventListener('wheel',e=>{e.preventDefault();zoomBy(e.deltaY<0?1.12:1/1.12);},{passive:false});
 canvas.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','+','-','Home'].includes(e.key))return;e.preventDefault();if(e.key==='Home')reset();else if(e.key==='+')zoomBy(1.2);else if(e.key==='-')zoomBy(1/1.2);else{yaw+=e.key==='ArrowLeft'?-.12:e.key==='ArrowRight'?.12:0;pitch+=e.key==='ArrowUp'?.12:e.key==='ArrowDown'?-.12:0;draw();}});
 const resize=new ResizeObserver(draw);resize.observe(canvas);
 const observer=new MutationObserver(()=>{const note=root.querySelector('textarea[name="f36c7b96-a57c-4ff4-9600-e3b1bb2c9667"]');if(note&&note.placeholder!==root.dataset.notes)note.placeholder=root.dataset.notes;});observer.observe(root.querySelector('.pg-form'),{childList:true,subtree:true});
 root.addEventListener('reset',()=>preview(null),true);
 document.addEventListener('shopify:section:unload',function cleanup(e){if(!e.target.contains(root))return;disposed=true;version++;resize.disconnect();observer.disconnect();if(url)URL.revokeObjectURL(url);if(gl){buffers.forEach(b=>gl.deleteBuffer(b));gl.deleteProgram(program);}document.removeEventListener('shopify:section:unload',cleanup);});
}
const boot=()=>document.querySelectorAll('[data-pg-root]').forEach(init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot);
})();


  } catch(e) { console.error(e); }
})();
})();
